import { useAtomValue } from 'jotai'
import React, { PropsWithChildren } from 'react'
import { Navigate } from 'react-router-dom'
import { buyTokenAtom, sellTokenAtom } from './stores/trade-store'

const ProtectRouter: React.FC<PropsWithChildren> = ({ children }) => {
  const sellToken = useAtomValue(sellTokenAtom)
  const buyToken = useAtomValue(buyTokenAtom)

  if (!sellToken || !buyToken) {
    return <Navigate to='/trade/swap' replace />
  }

  return children
}

export default ProtectRouter
